import api from "@modules/api/api";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { getProvinceByAbbr } from "@talladega/types";
import tradeInQueryKeys from "@modules/trade/types/tradeInQueryKeys";

type UpdateIcoDetailsRequest = {
  source: string;
  firstName: string;
  lastName: string;
  email: string | null;
  phone: string | null;
  address: string | null;
  city: string;
  province: string;
  postalCode: string | null;
  latitude: number | null;
  longitude: number | null;
  tradeInToken: string;
};

const postUpdateIcoDetails = async (req: UpdateIcoDetailsRequest) => {
  const { tradeInToken, ...rest } = req;

  return api.rawPut(`api/purchases/ico/${rest.source}/details`, {
    json: {
      ...rest,
      provinceId: getProvinceByAbbr(rest.province)?.id,
    },
    headers: {
      authorization: `Bearer ${tradeInToken}`,
    },
  });
};

export default function useUpdateIcoDetailsMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: postUpdateIcoDetails,
    onSuccess: (_, { tradeInToken }) => {
      queryClient.invalidateQueries({
        queryKey: tradeInQueryKeys.appraisalByToken(tradeInToken),
      });
    },
  });
}
